import React, { useState } from 'react';
import quoteData from './quoteData.js';

function QuoteButton({colourBlindMode}) {

  const [quote, setQuote] = useState("Inspire Me!");
  const [quotes, setQuotes] = useState([]);

  const getBackgroundColor = (colourBlindMode) => {
    switch (colourBlindMode) {
        case true:
            return "bg-[#FDC946]"
        default:
            return "bg-[#FACC15]";
    }
  };
  

  const getRandomQuote = () => {
    const randomIndex = Math.floor(Math.random() * quoteData.length);
    return quoteData[randomIndex].q;
  };

  const handleButtonClick = () => {
    const newQuote = getRandomQuote();
    setQuote(newQuote);

    setTimeout(() => {
      setQuote("Inspire Me!");
    }, 5000);
  };

  return (
    <div>
      <button
        className={`${getBackgroundColor(colourBlindMode)} hover:bg-yellow-500 text-black font-semibold py-2 px-4 rounded-full flex items-center`}
        onClick={handleButtonClick}
      >
        {quote}
        <i className="fa-solid fa-lightbulb ml-2"></i>
      </button>
    </div>
  );
}

export default QuoteButton;
